module.exports = __webpack_public_path__ + "img/perfect_pushup_splash.e732e767.jpg";